module.exports = __webpack_public_path__ + "img/citationchasercustom.39091519.png";